export interface AuthenticationResults {
  error?: string;
  error_description?: string;
}

/**
 * Parses the authentication results from the URL.
 * @param url
 * @constructor
 */
export function parseAuthenticationResults(
  url: string = window.location.href
): AuthenticationResults | false {
  const queryStringFragments = url.split("?").slice(1);

  if (queryStringFragments.length === 0) {
    return false;
  }

  // Join fragments with '&' to properly handle multiple question marks
  let queryString = queryStringFragments.join("&");

  if (queryString.indexOf("#") > -1) {
    queryString = queryString.substring(0, queryString.indexOf("#"));
  }

  const searchParams = new URLSearchParams(queryString);

  return {
    error: searchParams.get("error") || undefined,
    error_description: searchParams.get("error_description") || undefined,
  };
}

/**
 * Detects if there are any errors in the authentication results.
 * @param opts
 */
export function detectAuthenticationResults(
  opts: AuthenticationResults | false
): opts is AuthenticationResults {
  if (!opts) {
    return false;
  }

  const { error, error_description } = opts;
  return !!(error || error_description);
}

/**
 * Redirects the user to the login page with error details if there is an error in the authentication results.
 * @param opts
 * @returns {void}
 */
export function redirectToErrorPage(opts: AuthenticationResults): void {
  const { error, error_description } = opts;
  const searchParams = new URLSearchParams();
  if (error) searchParams.set("error", error);
  if (error_description) searchParams.set("error_description", error_description);
  // Use replace to prevent back navigation to error state after OAuth callback
  window.location.replace(`/login/identifier?${searchParams.toString()}`);
}
